<template>
<div class="admin-sidebar">
    <!-- Logo Section -->
    <!-- <div class="sidebar-header">
        <img src="../../assets/logo.png" alt="IdeasFundX" class="sidebar-logo" />
    </div> -->

    <!-- Navigation -->
    <nav class="sidebar-nav">
        <!-- Users Section -->
        <div class="nav-section">
            <h3 class="nav-section-title">USERS</h3>
            
            <div class="nav-item" :class="{ active: activePage === 'DashboardAdminCompany' }" @click="redirectTo('DashboardAdminCompany')">
                <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
                <span>Companies</span>
            </div>

            <div class="nav-item sub-item" :class="{ active: activePage === 'FindInvestors' }" @click="redirectTo('FindInvestors')">
                <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                <span>Find Investors</span>
            </div>

            <div class="nav-item" :class="{ active: activePage === 'DashboardAdminInvestor' }" @click="redirectTo('DashboardAdminInvestor')">
                <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <span>Investors</span>
            </div>

            <!-- Download Summary -->
            <div class="nav-item has-submenu" :class="{ expanded: dropdownSumarry }" @click="dropdownSumarry = !dropdownSumarry">
                <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                <span>Download Summary</span>
                <svg class="nav-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>

            <div class="submenu" :class="{ active: dropdownSumarry }">
                <div class="nav-item sub-item">
                    <export-excel
                        :data="summaryCompanies"
                        :fields="company_fields"
                        worksheet="Companies"
                        title="COMPANIES SUMMARY"
                        name="companies summary.xls"
                        class="export-link"
                    >
                        <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                        </svg>
                        <span>Companies</span>
                    </export-excel>
                </div>
                <div class="nav-item sub-item">
                    <export-excel
                        :data="summaryInvestors"
                        :fields="investor_fields"
                        worksheet="Investors"
                        title="INVESTORS SUMMARY"
                        name="investors summary.xls"
                        class="export-link"
                    >
                        <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                        </svg>
                        <span>Investors</span>
                    </export-excel>
                </div>
            </div>
        </div>

        <!-- Settings Section -->
        <div class="nav-section">
            <h3 class="nav-section-title" @click="settingsMenu = !settingsMenu" style="cursor: pointer;">
                SETTINGS
                <svg class="section-arrow" :class="{ rotated: settingsMenu }" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </h3>

            <div class="settings-menu" :class="{ active: settingsMenu }">
                <div class="nav-item" :class="{ active: $route.name === 'ExchangeRate' }" @click="changeComponent('ExchangeRate')">
                    <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="12" y1="1" x2="12" y2="23"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                    </svg>
                    <span>Exchange Rate</span>
                </div>

                <div class="nav-item" :class="{ active: $route.name === 'Coupon' }" @click="changeComponent('Coupon')">
                    <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20 12 20 22 4 22 4 12"></polyline>
                        <rect x="2" y="7" width="20" height="5"></rect>
                        <line x1="12" y1="22" x2="12" y2="7"></line>
                        <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
                        <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
                    </svg>
                    <span>Coupon</span>
                </div>

                <div class="nav-item logout" @click="submitLogout()">
                    <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    <span>Logout</span>
                </div>
            </div>
        </div>
    </nav>

    <!-- Footer -->
    <div class="sidebar-footer">
        <p>© 2025 IdeasFundX</p>
    </div>
</div>
</template>

<script>
import Company from "@/store/services/admin/company";
import Investor from "@/store/services/admin/investor";
export default {
    props: {
        comp_id: Number,
        array: Array,
        current: String,
    },

    data() {
        return {
            companies: [],
            summaryCompanies: [],
            summaryInvestors: [],
            companyMenu: true,
            settingsMenu: true,
            actual: null,
            company_id: null,
            company: {},
            rotation: false,
            activePage: '',
            dropdownSumarry: false,

            company_fields: {
                'Company-Id': 'id',
                'Company-Name': 'company_name',
                'Company Email': 'company_email',
                'Industry': 'industry',
                'Model' : 'model',
                'Location' : 'location',
                'Size' : 'size',
                'Growth' : 'growth',
                'Service Offer' : 'service_offer',
                'Technology focus' : 'technology_focus',
                'Technology' : 'technology',
                'Rd' : 'rd',
                'Exclusive Technology' : 'exclusive_technology',
                'Monthly Revenue' : 'monthly_revenue',
                'Country' : 'country',
                'Needed' : 'needed',
                'Stage' : 'stage',
                'Vehicle' : 'vehicle',
                'Female' : 'female',
                'Color' : 'color',
                'lgbtq' : 'lgbtq',
                'User Education/Schools' : 'user_education',
                'Team Founder School' : 'school',
                'Team Founder Country': 'team_founder_country',
                'Need Skills': 'skills',
            },
            investor_fields: {
                'id': 'id',
                'Investor-Name': 'investor_name',
                'Investor Email': 'investor_email',
                'Sectors': 'sectors',
                'Business models': 'business_models',
                'Market locations': 'market_locations',
                'Min_market size': 'min_market_size',
                'Min market growth': 'min_market_growth',
                'Product types': 'product_types',
                'Technology focus': 'technology_focus',
                'Technology type': 'technology_type',
                'Rd focus': 'rd_focus',
                'Patent focus': 'patent_focus',
                'Min monthly revenue': 'min_monthly_revenue',
                'Country': 'country',
                'Locations invested': 'locations_invested',
                'Min check size': 'min_check_size',
                'Max check size': 'max_check_size',
                'Stage': 'stage',
                'Investment_vehicles': 'investment_vehicles',
                'Usa corp structure': 'usa_corp_structure',
                'Preferred stages': 'preferred_stages',
                'Female' : 'female',
                'Color' : 'color',
                'lgbtq' : 'lgbtq',
                'User Education/Schools': 'school',
                'User Skills': 'skills',
            },
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],
        }
    },

    methods: {
        redirectTo(route) {
            if(route != this.activePage) {
                this.$router.push({ name: route });
            }
        },
        submitLogout() {
            localStorage.profile = '';
            this.$router.push('/admin');  
        },
        changeComponent(value) {
            this.$router.push({ name: value });
        },

        init(val, id) {
            this.companies = val;
            this.company_id = id;
            this.companies.forEach(company => {
                if (company.company_id == id) { this.company = company; }
            });
        },

        async getCompaniesSummary() {
            try {
                const response = await Company.getCompaniesSummary();
                
                this.summaryCompanies = response.data.map(company => {
                    const schools = company.team_founder.schools ? JSON.parse(company.team_founder.schools) : [];
                    let need_skills = [];
                    let educations = [];
                    company.need_skills.forEach(skill => {
                        need_skills.push(skill.skill);
                    });

                    company.user_education.forEach(education => {
                        educations.push(education.school);
                    });
                    return {
                        id: company.id,
                        company_name: company.company_name,
                        company_email: company?.user.email,
                        industry: Array.isArray(company?.business?.industry) ? company?.business?.industry.join(', ') : company?.business?.industry,
                        model: company?.business?.model,
                        location: company?.business?.location.join(', '),
                        size: company?.business?.size,
                        growth: company?.business?.growth,
                        service_offer: company?.business_products?.service_offer,
                        technology_focus: company?.business_products?.technology_focus ? "Yes" : "No",
                        technology: company?.business_products?.technology,
                        rd: company?.business_products?.rd ? "Yes" : "No",
                        exclusive_technology: company?.business_products?.exclusive_technology ? "Yes" : "No",
                        monthly_revenue: company?.finance?.monthly_revenue,
                        country: company.country,
                        needed: company?.needs?.needed,
                        stage: company?.investment?.stage,
                        vehicle: company?.need_investor?.vehicle,
                        female: company?.team_policies?.female ? "Yes" : "No",
                        color: company?.team_policies?.color ? "Yes" : "No",
                        lgbtq: company?.team_policies?.lgbtq ? "Yes" : "No",
                        user_education: educations.join(', '),
                        school: schools?.[0]?.school,
                        team_founder_country: company?.team_founder?.country,
                        skills : need_skills.join(', '),
                    };
                });
                return this.summaryCompanies;
            } catch (error) {
                console.error(error);
                return [];
            }
        },

        async getInvestorsSummary() {
            try {
                const response = await Investor.getInvestorsSummary();
                
                this.summaryInvestors = response.data.map(investor => {
                    let educations = [];
                    let skills = [];
                    investor.user_education.forEach(education => {
                        if (education.user_id == investor.id) {
                            educations.push(education.school);
                        }
                    });

                    investor.user_skill.forEach(skill => {
                        if (skill.user_id == investor.id) {
                            skills.push(skill.skill);
                        }
                    });

                    return {
                        id: investor.id,
                        investor_name: `${investor?.first_name} ${investor?.last_name}`,
                        investor_email: investor?.email,
                        sectors: Array.isArray(investor?.investor_strategy?.sectors) ? investor?.investor_strategy?.sectors.join(', ') : investor?.investor_strategy?.sectors,
                        business_models: Array.isArray(investor?.investor_strategy?.business_models) ? investor?.investor_strategy?.business_models.join(', ') : investor?.investor_strategy?.business_models,
                        market_locations: Array.isArray(investor?.investor_strategy?.market_locations) ? investor?.investor_strategy?.market_locations.join(', ') : investor?.investor_strategy?.market_locations,
                        min_market_size: investor?.investor_strategy?.min_market_size,
                        min_market_growth: investor?.investor_strategy?.min_market_growth,
                        product_types: Array.isArray(investor?.investor_strategy?.product_types) ? investor?.investor_strategy?.product_types.join(', ') : investor?.investor_strategy?.product_types,
                        technology_focus: investor?.investor_strategy?.technology_focus,
                        technology_type: investor?.investor_strategy?.technology_type,
                        rd_focus: investor?.investor_strategy?.rd_focus,
                        patent_focus: investor?.investor_strategy?.patent_focus,
                        min_monthly_revenue: investor?.investor_strategy?.min_monthly_revenue,
                        country: investor?.investor_accreditation?.country,
                        locations_invested: Array.isArray(investor?.investor_strategy?.locations_invested) ? investor?.investor_strategy?.locations_invested.join(', ') : investor?.investor_strategy?.locations_invested,
                        min_check_size: investor?.investor_accreditation?.min_check_size,
                        max_check_size: investor?.investor_accreditation?.max_check_size,
                        stage: Array.isArray(investor?.investor_strategy?.stage) ? investor?.investor_strategy?.stage.join(', ') : investor?.investor_strategy?.stage,
                        investment_vehicles: Array.isArray(investor?.investor_accreditation?.investment_vehicles) ? investor?.investor_accreditation?.investment_vehicles.join(', ') : investor?.investor_accreditation?.investment_vehicles,
                        female: investor?.investor_accreditation?.female ? "Yes" : "No",
                        color: investor?.investor_accreditation?.color ? "Yes" : "No",
                        lgbtq: investor?.investor_accreditation?.lgbtq ? "Yes" : "No",
                        usa_corp_structure: investor?.investor_strategy?.usa_corp_structure ? "Yes" : "No",
                        preferred_stages: Array.isArray(investor?.investor_strategy?.preferred_stages) ? investor?.investor_strategy?.preferred_stages.join(', ') : investor?.investor_strategy?.preferred_stages,
                        school: educations.join(', '),
                        skills: skills.join(', ')
                    };
                });
                return this.summaryInvestors;
            } catch (error) {
                console.error(error);
                return [];
            }
        }
    },

    created() {
        this.getCompaniesSummary();
        this.getInvestorsSummary();

        this.activePage = this.$route.name;
        if (this.comp_id) {
            this.companies = this.array;
            this.company_id = this.comp_id;
            this.companies.forEach(company => {
                if (company.company_id == this.comp_id) { this.company = company; }
            });
        }
    }
}
</script>

<style scoped>
.admin-sidebar {
    width: 280px;
    height: calc(100vh - 70px);
    background: #ffffff;
    border-right: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    position: fixed;
    top: 70px;
    left: 0;
    overflow-y: auto;
    z-index: 99;
}

/* Header / Logo */
.sidebar-header {
    padding: 24px 20px;
    border-bottom: 1px solid #e5e7eb;
}

.sidebar-logo {
    height: 40px;
    width: auto;
}

/* Navigation */
.sidebar-nav {
    flex: 1;
    padding: 20px 0;
    overflow-y: auto;
}

.nav-section {
    margin-bottom: 24px;
}

.nav-section-title {
    font-size: 11px;
    font-weight: 700;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 0 20px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.section-arrow {
    transition: transform 0.3s ease;
}

.section-arrow.rotated {
    transform: rotate(180deg);
}

/* Nav Items */
.nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 20px;
    color: #4b5563;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    font-weight: 500;
    position: relative;
}

.nav-item:hover {
    background: rgba(0, 170, 195, 0.08);
    color: #00aac3;
}

.nav-item.active {
    background: linear-gradient(135deg, #00aac3 0%, #0891b2 100%);
    color: white !important;
    border-radius: 0 24px 24px 0;
    margin-right: 16px;
}

.nav-item.active .nav-icon {
    color: white;
}

.nav-item.sub-item {
    padding-left: 52px;
}

.nav-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: #6b7280;
    transition: color 0.2s ease;
}

.nav-item:hover .nav-icon {
    color: #00aac3;
}

/* Submenu Arrow */
.nav-arrow {
    margin-left: auto;
    transition: transform 0.3s ease;
}

.nav-item.has-submenu.expanded .nav-arrow {
    transform: rotate(180deg);
}

/* Submenu */
.submenu {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
}

.submenu.active {
    max-height: 200px;
}

/* Export Link */
.export-link {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    color: inherit;
    text-decoration: none;
}

/* Settings Menu */
.settings-menu {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
}

.settings-menu.active {
    max-height: 300px;
}

/* Logout */
.nav-item.logout:hover {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
}

.nav-item.logout:hover .nav-icon {
    color: #ef4444;
}

/* Footer */
.sidebar-footer {
    padding: 20px;
    border-top: 1px solid #e5e7eb;
    text-align: center;
}

.sidebar-footer p {
    font-size: 12px;
    color: #9ca3af;
    margin: 0;
}
</style>